/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */
import _ from 'lodash';
import React from 'react';

import { List } from '@mairistem/composants';

import {
  DiplomeListeContainer,
  ProfessionListeContainer,
  SituationScolaireListeContainer,
  SpecialiteListeContainer,
} from '@/components/Listes';

import {
  ParametreBackground,
  ParametreButton,
  ModalParametresGeneraux,
} from '@/components/Parametres';

import { QUALIFICATION_ATTRIBUTES } from '@/constants';
import { Qualification } from '@/enums';
import { Parametres } from '@/types';
import { toast } from 'react-toastify';
import { ListeParametrableModal } from '@mairistem/liste';
import { useParametresStore } from '@/zustand';

interface ParameterPageProps {
  generaux?: boolean;
}
const ParameterPage = (props: ParameterPageProps) => {
  const { generaux = false } = props;

  const [scolariteModalOpen, setScolariteModalOpen] =
    React.useState<Qualification | null>(null);
  const [active, setActive] = React.useState<Parametres | null>(null);

  const parametres = useParametresStore((state) => state.parametres);

  React.useEffect(() => {
    if (generaux && _.isNil(parametres?.identifiant)) {
      toast(
        'Il est nécessaire de remplir les paramètres généraux afin de continuer',
        { type: 'info' },
      );
      setActive(Parametres.Generaux);
    } else if (generaux && !_.isNil(parametres?.identifiant)) {
      setActive(Parametres.Generaux);
    }
  }, [generaux, parametres?.identifiant]);

  const listToRender = React.useMemo(() => {
    switch (scolariteModalOpen) {
      case Qualification.Diplome:
        return <DiplomeListeContainer />;

      case Qualification.Specialite:
        return <SpecialiteListeContainer />;

      case Qualification.SituationScolaire:
        return <SituationScolaireListeContainer />;

      default:
        return <h1>Une erreur est survenue...</h1>;
    }
  }, [scolariteModalOpen]);

  const primaryButton = React.useMemo(() => {
    switch (active) {
      case Parametres.Generaux:
        return <ParametreBackground color="teal" content="GÉNÉRAUX" />;

      case Parametres.Utilisateur:
        return <ParametreBackground color="#f2711c" content="UTILISATEUR" />;

      case Parametres.Scolarite:
        return (
          <ParametreBackground color="#6436c9">
            <div>
              <h1 style={{ textAlign: 'center' }}>SCOLARITÉ</h1>
              <List animated style={{ fontSize: '1.35rem', cursor: 'pointer' }}>
                <List.Item
                  content="> Situations scolaires"
                  data-testid="parameter-page-list-item-situations-scolaires"
                  onClick={() =>
                    setScolariteModalOpen(Qualification.SituationScolaire)
                  }
                />
                <List.Item
                  content="> Diplômes"
                  data-testid="parameter-page-list-item-diplomes"
                  onClick={() => setScolariteModalOpen(Qualification.Diplome)}
                />
                <List.Item
                  content="> Spécialités"
                  data-testid="parameter-page-list-item-specialites"
                  onClick={() =>
                    setScolariteModalOpen(Qualification.Specialite)
                  }
                />
              </List>
            </div>
            {/* Diplômes */}
            {!_.isNil(scolariteModalOpen) && (
              <ListeParametrableModal
                parametrage
                onClose={() => setScolariteModalOpen(null)}
                icon={QUALIFICATION_ATTRIBUTES[scolariteModalOpen]?.icon}
                header={QUALIFICATION_ATTRIBUTES[scolariteModalOpen]?.title}
              >
                {listToRender}
              </ListeParametrableModal>
            )}
          </ParametreBackground>
        );

      case Parametres.Profession:
        return <ParametreBackground color="#971c82" content="PROFESSIONS" />;

      case Parametres.MessagesTypes:
        return <ParametreBackground color="#e03997" content="MESSAGES TYPES" />;

      default:
        return <ParametreBackground color="#96c11f" content="PARAMÈTRES" />;
    }
  }, [listToRender, active, scolariteModalOpen]);

  // NOTE: First version, before removing "Message Types" and "Utilisateur" buttons for V1.0
  // const secondaryButtons = React.useMemo(() => (
  //   <>
  //     <div style={{ position: 'absolute', marginTop: '-42rem' }}>
  //       <ParametreButton
  //         icon={{
  //           name: 'settings',
  //           size: 'large',
  //         }}
  //         dataTestId="secondary-parameter-button-generaux"
  //         content="GÉNÉRAUX"
  //         color="teal"
  //         textPosition="top"
  //         active={active === Parametres.Generaux}
  //         onClick={() => setActive(Parametres.Generaux)}
  //       />
  //     </div>
  //     <div style={{ position: 'absolute', marginTop: '-16rem', marginRight: '-46rem' }}>
  //       <ParametreButton
  //         icon={{
  //           name: 'user circle',
  //           size: 'large',
  //         }}
  //         dataTestId="secondary-parameter-button-utilisateur"
  //         content="UTILISATEUR"
  //         disabled
  //         color="orange"
  //         textPosition="right"
  //         active={active === Parametres.Utilisateur}
  //         onClick={() => setActive(Parametres.Utilisateur)}
  //       />
  //     </div>
  //     <div style={{ position: 'absolute', marginTop: '28rem', marginRight: '-36rem' }}>
  //       <ParametreButton
  //         icon={{
  //           name: 'graduation cap',
  //           size: 'large',
  //         }}
  //         dataTestId="secondary-parameter-button-scolarite"
  //         content="SCOLARITÉ"
  //         color="violet"
  //         textPosition="right"
  //         active={active === Parametres.Scolarite}
  //         onClick={() => setActive(Parametres.Scolarite)}
  //       />
  //     </div>
  //     <div style={{ position: 'absolute', marginTop: '28rem', marginLeft: '-38rem' }}>
  //       <ParametreButton
  //         icon={{
  //           name: 'briefcase',
  //           size: 'large',
  //         }}
  //         dataTestId="secondary-parameter-button-professions"
  //         content="PROFESSIONS"
  //         color="purple"
  //         textPosition="left"
  //         active={active === Parametres.Profession}
  //         onClick={() => setActive(Parametres.Profession)}

  //       />
  //     </div>
  //     <div style={{ position: 'absolute', marginTop: '-16rem', marginLeft: '-50rem' }}>
  //       <ParametreButton
  //         icon={{
  //           name: 'file alternate outline',
  //           size: 'large',
  //         }}
  //         dataTestId="secondary-parameter-button-messages-types"
  //         content="MESSAGES TYPES"
  //         disabled
  //         color="pink"
  //         textPosition="left"
  //         active={active === Parametres.MessagesTypes}
  //         onClick={() => setActive(Parametres.MessagesTypes)}
  //         secondary
  //       />
  //     </div>
  //   </>
  // ), [active]);

  const secondaryButtons = React.useMemo(
    () => (
      <>
        <div style={{ position: 'absolute', marginTop: '-42rem' }}>
          <ParametreButton
            icon={{
              name: 'settings',
              size: 'large',
            }}
            dataTestId="secondary-parameter-button-generaux"
            content="GÉNÉRAUX"
            color="teal"
            textPosition="top"
            active={active === Parametres.Generaux}
            onClick={() => setActive(Parametres.Generaux)}
          />
        </div>
        <div
          style={{
            position: 'absolute',
            marginTop: '20rem',
            marginRight: '-42rem',
          }}
        >
          <ParametreButton
            icon={{
              name: 'graduation cap',
              size: 'large',
            }}
            dataTestId="secondary-parameter-button-scolarite"
            content="SCOLARITÉ"
            color="violet"
            textPosition="right"
            active={active === Parametres.Scolarite}
            onClick={() => setActive(Parametres.Scolarite)}
          />
        </div>
        <div
          style={{
            position: 'absolute',
            marginTop: '20rem',
            marginLeft: '-45rem',
          }}
        >
          <ParametreButton
            icon={{
              name: 'briefcase',
              size: 'large',
            }}
            dataTestId="secondary-parameter-button-professions"
            content="PROFESSIONS"
            color="purple"
            textPosition="left"
            active={active === Parametres.Profession}
            onClick={() => setActive(Parametres.Profession)}
          />
        </div>
      </>
    ),
    [active],
  );

  return (
    <div
      style={{
        marginTop: '12em',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flex: 1,
      }}
    >
      {primaryButton}
      {secondaryButtons}
      {active === Parametres.Generaux && (
        <ModalParametresGeneraux
          onClose={() => setActive(null)}
          redirect={generaux}
          gestionHubee={generaux && !_.isNil(parametres?.identifiant)}
        />
      )}
      {active === Parametres.Profession && (
        <ListeParametrableModal
          parametrage
          onClose={() => setActive(null)}
          icon={QUALIFICATION_ATTRIBUTES[Qualification.Profession]?.icon}
          header={QUALIFICATION_ATTRIBUTES[Qualification.Profession]?.title}
        >
          <ProfessionListeContainer isShowingCaduque />
        </ListeParametrableModal>
      )}
    </div>
  );
};

export default ParameterPage;
